<template>
  <div class="contacts-terminals-slider">
    <vueper-slides
      ref="slider"
      v-if="items"
      slide-multiple
      :bullets="false"
      :visible-slides="4"
      :touchable="false"
      :arrows-outside="true"
      :breakpoints="{ 1281: { visibleSlides: 3 }, 1088: { visibleSlides: 2 }, 769: { visibleSlides: 1 } }"
      :class="{ 'static': !canSlide }"
    >
      <template v-if="isReady">
        <vueper-slide v-for="(item, index) in items" :key="index">
          <template #content>
            <vz-button
              large
              outline
              :class="{ 'active': item.guid === modelValue }"
              @click="onChange(item)"
            >
              <vz-icon
                name="map-marker"
                size="16"
              />
              {{ item.title }}
            </vz-button>
          </template>
        </vueper-slide>
      </template>
    </vueper-slides>
  </div>
</template>

<script setup lang="ts">
import {Terminal, TerminalPurpose} from '~/types/types'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import {useTerminalStore} from '~/stores/terminal';
import {PropType} from 'vue';

const emit = defineEmits(['change'])

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  locationGuid: {
    type: String,
    default: ''
  },
  purpose: {
    type: String as PropType<TerminalPurpose | ''>,
    default: ''
  }
})

const { terminalSelectByLocation } = useTerminalStore()

const slider = ref<typeof VueperSlides|null>(null)

const canSlide = computed(() => {
  return !!slider?.value?.canSlide
})

const isReady = computed(() => {
  return !!slider?.value?.isReady
})

const items = computed(() => {
  return terminalSelectByLocation(props.locationGuid, props.purpose).map(t => ({
    ...t,
    icon: { name: 'map-marker', size: 16 },
  }))
})

const onChange = (item: Terminal): void => {
  if (props.modelValue !== item.guid) {
    emit('change', item)
  }
}
</script>
